<template>
  <v-row no-gutters>
    <v-col cols="12">
      <!-- <v-avatar :color="$vuetify.theme.dark === true ? '#FFFFFF0A' : '#00000009'" :size="avatarStyle.size + 80"> -->
      <!-- style="border-style: solid; border-color: red green blue; border-style: solid; border-width: 2px;" -->
      <v-avatar :color="$vuetify.theme.dark === true ? '#FFFFFF0F' : '#0000000F'" :size="avatarSize">
        <v-row no-gutters justify="center">
          <template v-if="textHeaderTop != null">
            <v-col cols="12" align="center">
              <h3 :style="textHeaderTopStyle">{{ textHeaderTop }}</h3>
            </v-col>
          </template>

          <template v-if="isBattery === true">
            <template v-if="power < 0">
              <BatterySoC class="text-center" :size="iconStyle.size" :SoC="soc" :Charging="true" :ChargingRate="100" :Unknown="false" :PrimaryColor="false"> </BatterySoC>
            </template>
            <template v-else>
              <BatterySoC class="text-center" :size="iconStyle.size" :SoC="soc" :Charging="false" :ChargingRate="100" :Unknown="false" :PrimaryColor="false"></BatterySoC>
            </template>
          </template>
          <template v-else>
            <v-icon v-for="(icon, index) in icons" :index="index" :key="icon.id" v-bind:style="iconStyle" :color="colorsAvatar[index]">
              {{ icon }}
            </v-icon>
          </template>
        </v-row>
      </v-avatar>
    </v-col>

    <template v-if="textHeaderBot != null">
      <v-col cols="12">
        <h3 :style="textHeaderBotStyle">{{ textHeaderBot }}</h3>
      </v-col>
    </template>

    <v-col cols="12" class="my-2">
      <v-carousel v-model="carousel1" :light="!$vuetify.theme.dark" :dark="$vuetify.theme.dark" height="auto" cycle interval="5000" :show-arrows="false" hide-delimiter-background hide-delimiters>
        <v-carousel-item v-for="(item, index) in carouselTextSubHeaderBot" :index="index" :key="item.id">
          <!--           <v-tooltip x-small bottom :color="colors[index]">
            <template v-slot:activator="{ on, attrs }"> -->
          <!--               <v-icon :color="colors[index]" dark v-bind="attrs" v-on="on">
                    mdi-message-question-outline
                  </v-icon> -->
          <b class="heading-6" :style="carouselTextSubHeaderBotStyle[index]">{{ item }}</b>

          <!--  v-bind="attrs" v-on="on" -->
          <!--             </template>
            <span> {{ carouselTooltipContent[index] }}</span>
          </v-tooltip> -->
        </v-carousel-item>
      </v-carousel>

      <v-carousel v-model="carousel2" :light="!$vuetify.theme.dark" :dark="$vuetify.theme.dark" height="auto" cycle interval="5000" :show-arrows="false" hide-delimiter-background hide-delimiters>
        <v-carousel-item v-for="(item, index) in carouselText2SubHeaderBot" :index="index" :key="item.id">
          <!--           <v-tooltip x-small bottom :color="colors[index]">
            <template v-slot:activator="{ on, attrs }"> -->
          <!--               <v-icon :color="colors[index]" dark v-bind="attrs" v-on="on">
                    mdi-message-question-outline
                  </v-icon> -->
          <b class="heading-6" :style="carouselText2SubHeaderBotStyle[index]">{{ item }}</b>

          <!--  v-bind="attrs" v-on="on" -->
          <!--             </template>
            <span> {{ carouselTooltip2Content[index] }}</span>
          </v-tooltip> -->
        </v-carousel-item>
      </v-carousel>
    </v-col>
  </v-row>
</template>

<script>
import BatterySoC from "../battery/BatterySoC.vue";

export default {
  name: "AvatarUnit2",
  components: {
    BatterySoC,
  },
  props: {
    avatarSize: {
      type: Number,
    },
    iconStyle: {
      type: Object,
    },
    icons: {
      type: Array,
    },
    colors: {
      type: Array,
    },
    colorsAvatar: {
      type: Array,
    },
    power: {
      type: Number,
    },
    textHeaderTop: {
      type: String,
    },
    textHeaderTopStyle: {
      type: String,
    },
    textHeaderBot: {
      type: String,
    },
    textHeaderBotStyle: {
      type: String,
    },
    carouselTextSubHeaderBot: {
      type: Array,
    },
    carouselTextSubHeaderBotStyle: {
      type: Array,
    },
    carouselTooltipContent: {
      type: Array,
    },
    carouselText2SubHeaderBot: {
      type: Array,
    },
    carouselText2SubHeaderBotStyle: {
      type: Array,
    },
    carouselTooltip2Content: {
      type: Array,
    },
    soc: {
      type: Number,
    },
    isBattery: {
      type: Boolean,
    },
  },
  data() {
    return {
      carousel1: 0,
      carousel2: 0,
    };
  },
};
</script>

<style scoped>
/* .h3 {
      text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
    }
     */
.v-icon {
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);
}
</style>
